<template>
  <v-container fluid>
    <div class="d-flex align-center mt-1 mb-3">
      <div class="ml-2 font-weight-medium">Resend Transaction</div>
    </div>
    <v-card outlined min-width="100%" class="px-4">
      <div class="d-flex align-end flex-wrap py-4">
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่เริ่มต้น
          </div>
          <date-picker
            v-model="dateStart"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :clearable="false"
            :disabled-date="disabledAfterDateEnd"
            :disabled-time="disabledAfterDateEnd"
          ></date-picker>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่สิ้นสุด
          </div>
          <date-picker
            v-model="dateEnd"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :clearable="false"
            :disabled-date="disabledBeforeDateStart"
            :disabled-time="disabledBeforeDateStart"
          ></date-picker>
        </div>
        <div class="mb-1">
          <v-btn
            class="text-capitalize"
            :disabled="loading"
            depressed
            color="primary"
            @click="handleResendTransaction"
            >Resend</v-btn
          >
        </div>
      </div>
    </v-card>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      isFetching: false,
      timerId: null,
      cancelSource: null,

      loading: false,
      dateStart: new Date(new Date().setHours(0, 0, 0, 0)),
      dateEnd: new Date(new Date().setHours(23, 59, 59, 0)),
      dialogProgress: false,
      progressValue: 0,
      jobProcessData: {},
      timeout: null,
    }
  },
  filters: {
    dateFormat: function (item) {
      return moment
        .utc(item.transaction_time)
        .utcOffset(item.timezone)
        .format('DD/MM/YYYY HH:mm:ss')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'Resend Transaction',
        disabled: true,
      },
    ])
  },
  methods: {
    ...mapActions({
      webhookResendTransaction: 'webhook/webhookResendTransaction',
      jobProcess: 'download/jobProcess',
    }),
    disabledAfterDateEnd(date) {
      return date > new Date(this.dateEnd)
    },
    disabledBeforeDateStart(date) {
      return date < new Date(this.dateStart)
    },
    async fetchProgress() {
      if (this.isFetching) return
      this.isFetching = true

      const controller = new AbortController()
      this.cancelSource = controller

      try {
        const payload = {
          job_process_uuid: this.jobProcessData.job_process_uuid,
          signal: controller.signal,
        }

        const res = await this.jobProcess(payload)
        if (res.is_success) {
          this.progressValue = 100

          clearTimeout(this.timerId)
          this.timerId = null

          this.timeout = setTimeout(() => {
            this.dialogProgress = false
          }, 200)
        } else {
          this.progressValue = (100 / res.total) * res.progress

          this.timerId = setTimeout(
            () => this.fetchProgress(),
            res.ping_after_ms
          )
        }
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        this.timeout = setTimeout(() => {
          this.dialogProgress = false
        }, 200)

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.isFetching = false
      }
    },
    stopPolling() {
      clearTimeout(this.timerId)
      this.timerId = null
      if (this.cancelSource) this.cancelSource.abort()
    },

    async handleResendTransaction() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            start_datetime: moment(this.dateStart).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            end_datetime: moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
          },
        }

        this.loading = true
        const response = await this.webhookResendTransaction(payload)
        this.jobProcessData = {
          job_process_uuid: response.job_process_uuid,
          ping_after_ms: response.ping_after_ms,
        }
        this.dialogProgress = true
        this.fetchProgress()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)

    this.stopPolling()
  },
}
</script>
